import React, { PureComponent } from 'react';
import { Button, Icon } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { returnDate } from '../../common/utils';
import { PC_MONITOR } from '../../config/media';

class ExchangeInfo extends PureComponent {
	state = {
		isHide: true,
	};

	listing = (exchange, property) => {
		if (
			exchange.hasOwnProperty('info') &&
			exchange.info.hasOwnProperty('biz')
		) {
			const properties = exchange.info.biz[property];
			if (properties !== undefined) {
				return properties.map((item) => {
					if (property === 'ASSETS') {
						return ` ${item.ASSET_SYMBOL} `;
					}
					if (property === 'PAIRS') {
						return ` ${item.BASE_ASSET}-${item.PRICED_ASSET} `;
					}
					return '';
				});
			}
		}
		return null;
	};

	render() {
		const { data, location, history, goToSetup, download } = this.props;
		const { isHide } = this.state;
		if (data.length === 0) {
			return (
				<div className="info-container">
					<h2>
						<b>First-Time Exchange Operator</b>
					</h2>
					<div>
						Start an exchange for free in minutes by clicking create
						exchange below. <br />
						Follow the 5 steps and create brand new marketplaces.
					</div>
					<Button
						block
						type="primary"
						onClick={() => {
							history.push('/exchange/new');
						}}
					>
						Create Exchange
					</Button>
				</div>
			);
		}
		let exchange = data[0];
		if (location.search !== '') {
			const id = location.search.split('=')[1];
			exchange = data.filter((item) => {
				return item.id === parseInt(id, 10);
			});
			exchange = exchange[0];
		}
		return (
			<div>
				<div className="img-container">
					<img src={PC_MONITOR} alt="pc_monitor" />
					{data.length === 0 ? null : (
						<div className="setup-btn">
							<Button block type="primary" onClick={goToSetup}>
								Exchange Setup
							</Button>
							<br />
							{/* <Link to="/exchange/preview">
										Exchange Preview Page
									</Link> */}
							<span className="download" onClick={download}>
								Export Setup File
							</span>
						</div>
					)}
				</div>
				<div className="info-container">
					<h2>
						<b>Exchange Details</b>
					</h2>
					<p>
						<b>Hosting:</b>
						{exchange.type === 'Cloud'
							? moment(exchange.expiry).diff(moment(), 'days') <= 0
								? <span className="expired">Cloud expired <Link to="/billing">(Billing)</Link></span>
								: <span>Cloud</span>
							: exchange.is_collateralized
							? <span>{exchange.type}</span>
							: <span>
								{exchange.type}
								<Link to="/collateral">(Collateralize)</Link>{' '}
								<Link to="/collateral">(Get sponsorship)</Link>
							</span>
						}
					</p>
					<p>
						<b>Exchange Name:</b> {exchange.name}
					</p>
					<p>
						<b>Exchange URL:</b>{' '}
						{exchange.info.tech && exchange.info.tech.EXCHANGE_CLIENT_URL}
					</p>
					<p className="activation-code">
						<b>Activation Code:</b>{' '}
						<span className={isHide ? 'hide' : ''}>
							{exchange.activation_code}
						</span>{' '}
						<Icon
							type={isHide ? 'eye' : 'eye-invisible'}
							style={{ color: '#fff' }}
							onClick={() => {
								this.setState({ isHide: !isHide });
							}}
						/>
					</p>
					<p>
						<b>Created:</b> {returnDate(exchange.created_at)}
					</p>
					<p>
						<b>Billing Status:</b>
						{exchange.is_collateralized
							? <span>N/A</span>
							:
							(exchange.type === 'Cloud')
							? exchange.is_paid
								? (
									<span>Paid (<Link to="/billing">Billing</Link>)</span>
								) : (<Link to="/billing">Payment required</Link>)
							: (!exchange.expiry || moment(exchange.expiry).diff(moment(), 'days') < 0)
								? <span>Expired</span>
								: <span>
									Trial{' '}
									({moment(exchange.expiry).diff(moment(), 'days')} days left){' '}
								(<Link to="/collateral">Collateralize</Link>)
								</span>
						}
					</p>
					<p>
						<b>Expired:</b>{' '}
						{!exchange.is_collateralized ? returnDate(exchange.expiry) : 'N/A'}
					</p>
					<p>
						<b>Collateral:</b> {exchange.amount} XHT
					</p>
					<p>
						<b>Assets:</b> {this.listing(exchange, 'ASSETS')}
					</p>
					<p>
						<b>Trading Pairs:</b> {this.listing(exchange, 'PAIRS')}
					</p>
					<p>
						<b>Logo:</b>{' '}
						<img
							src={exchange.info.biz.LOGO_IMAGE_LIGHT}
							alt="logo"
							className="logo-img"
						/>
					</p>
					<p>
						<b>Theme:</b> {exchange.info.biz.DEFAULT_COLOR}
					</p>
					<p>
						<b>Language:</b> {exchange.info.biz.LANGUAGE}
					</p>
				</div>
			</div>
		);
	}
}

export default ExchangeInfo;
